import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getMerchantServicesService,
  bookMerchantServicesService,
  getMerchantServiceService,
} from "../../services/merchant.service";
import {
  getAllServicesService,
  getServiceDetailsByMerchantIdService,
  getServiceDetailsByMerchantIdAndMonthService,
  getServicesMaxPriceService,
  updateUserGeolocationService,
} from "services/services.service";

// NEW 👇
export const getAllServices = createAsyncThunk(
  "/getAllServices",
  async (params, { rejectWithValue }) => {
    return await getAllServicesService(params, rejectWithValue);
  }
);

export const getServiceDetailsByMerchantId = createAsyncThunk(
  "/getServiceDetailsByMerchantId",
  async (params, { rejectWithValue }) => {
    return await getServiceDetailsByMerchantIdService(params, rejectWithValue);
  }
);

export const getServiceDetailsByMerchantIdAndMonth = createAsyncThunk(
  "/getServiceDetailsByMerchantIdAndMonth",
  async (params, { rejectWithValue }) => {
    return await getServiceDetailsByMerchantIdAndMonthService(
      params,
      rejectWithValue
    );
  }
);

export const getServicesMaxPrice = createAsyncThunk(
  "getMaxPrice",
  async (params, { rejectWithValue }) => {
    return await getServicesMaxPriceService(params, rejectWithValue);
  }
);

export const updateUserGeolocation = createAsyncThunk(
  "updateUserGeolocation",
  async (params, { rejectWithValue }) => {
    return await updateUserGeolocationService(params, rejectWithValue);
  }
);

// OLD 👇

export const getMerchantService = createAsyncThunk(
  "/getMerchantService",
  async (params, { rejectWithValue }) => {
    return await getMerchantServiceService(params, rejectWithValue);
  }
);

export const bookMerchantService = createAsyncThunk(
  "/bookMerchantService",
  async (payload, { rejectWithValue }) => {
    return await bookMerchantServicesService(payload, rejectWithValue);
  }
);
